var map = {
	"./Avatar_1.png": 1094,
	"./Avatar_10.png": 698,
	"./Avatar_2.png": 7027,
	"./Avatar_3.png": 3495,
	"./Avatar_4.png": 1442,
	"./Avatar_5.png": 9391,
	"./Avatar_6.png": 8953,
	"./Avatar_7.png": 6311,
	"./Avatar_8.png": 8258,
	"./Avatar_9.png": 294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8517;